export default __webpack_public_path__ + "static/media/page404animation.16578780.gif";